import Swiper from 'swiper'
import {Navigation, Pagination, Autoplay} from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-image-slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-image-slider__swiper')
            const nextButton = sliderWrapper.querySelector('.swiper-next')
            const prevButton = sliderWrapper.querySelector('.swiper-prev')
            const customPagination = sliderWrapper.querySelector('.swiper-pagination-custom')
            const slideElements = sliderWrapper.querySelectorAll('.mtt-image-slide')

            if (slideElements.length < 2) {
                return
            }

            let swiperOptions = {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },
            }

            if (customPagination) {
                swiperOptions.pagination = {
                    el: customPagination,
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => {
                        return `<div class="${className}"><div class="swiper-pagination-progress"></div><div>${slideElements[index].getAttribute('data-slide-title')}</div></div>`
                    }
                }
            } else {
                swiperOptions.pagination = {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)
            swiper.on('slideChange', () => sliderWrapper.classList.add('swiper-changed'))
        })
    }
})
